import { clsx } from "clsx";
import type { HourForecast } from "../types.ts";
import { ConditionIcon } from "./condition-icon.tsx";

export function formatTemp(value: number | null): string {
	return value === null ? "—°" : `${value}°`;
}

export function HourlyStrip({ hours }: { hours: HourForecast[] }) {
	return (
		<ul className="weather-hourly">
			{hours.map((hour) => (
				<li
					key={hour.bucketTime}
					className={clsx("weather-hour", !hour.workable && "is-not-workable")}
				>
					<span className="weather-hour__time">{hour.time}</span>
					<ConditionIcon
						condition={hour.condition}
						className="weather-hour__icon"
					/>
					<span className="weather-hour__temp">{formatTemp(hour.temp)}</span>
				</li>
			))}
		</ul>
	);
}
